import { render, staticRenderFns } from "./TCISwitch.vue?vue&type=template&id=5b306c9a&"
import script from "./TCISwitch.vue?vue&type=script&lang=js&"
export * from "./TCISwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports